import React, { useEffect, useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
import HoursOfOperationForm from './HoursOfOperationForm';
import { toast } from 'react-toastify';
import Loading from "../../../../common/Loading";

const HoursOfOperation = () => {
    const [clinic, setClinic] = useState({});
    const [loading, setLoading] = useState(true);
    const { clinicId } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [hours, setHours] = useState([]);

    useEffect(() => {
        setLoading(true);
        clinicService.getHours(clinicId)
            .then(hours => {
                setHours(hours.data);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                toast.error("Error while retrieving hours of operation", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
    }, [clinicId]);

    const updateHours = (hours) => {
        setHours(hours);
        setIsEditing(false);
        toast.success("Hours updated successfully!", {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    };

    const cancelEditing = () => {
        setIsEditing(false);
        toast.info("Editing cancelled", {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    };

    return (
        <div className="container-fluid p-0">
            <div className="card card-padding shadow-none">
                <div className="card-title bg-transparent py-3 d-flex justify-content-between align-items-center">
                    <div className="mb-0 d-flex align-items-center">
                        <i className="bi bi-clock-history me-2 text-primary"></i>
                        Hours of Operation
                    </div>
                    <div>
                        {isEditing ? (
                            <button
                                className="btn btn-outline-danger btn-sm ms-2"
                                onClick={cancelEditing}
                            >
                                <i className="bi bi-x-circle me-1"></i> Cancel
                            </button>
                        ) : (
                            <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => setIsEditing(true)}
                            >
                                <i className="bi bi-pencil-square me-1"></i> Edit Hours
                            </button>
                        )}
                    </div>
                </div>

                <div className="card-body p-0">
                    {loading ? (
                        <Loading />
                    ) : isEditing ? (
                        <HoursOfOperationForm hof={hours} updateHours={updateHours} cancelEditing={cancelEditing} />
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover align-middle mb-0">
                                <thead>
                                <tr>
                                    <th className="ps-4 col-2">
                                        <i className="bi bi-calendar3 me-2"></i>Day
                                    </th>
                                    <th className="ps-4 col-4">
                                        <i className="bi bi-watch me-2"></i>Operating Hours
                                    </th>
                                    <th className="ps-4 col-2">
                                        <i className="bi bi-toggle-on me-2"></i>Status
                                    </th>
                                    <th className="ps-4 col-4">
                                        <i className="bi bi-sticky me-2"></i>Notes
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {hours.map(hour => (
                                    <tr key={hour.id} className={hour.status ? "" : "bg-light"}>
                                        <td className="ps-4 fw-bold">{hour.day}</td>
                                        <td>
                                            {hour.status ? (
                                                <span className="badge bg-light text-dark border">
                                                        <i className="bi bi-clock me-1"></i>
                                                    {hour.start} - {hour.end}
                                                    </span>
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </td>
                                        <td>
                                            {hour.status ? (
                                                <span className="badge bg-success bg-opacity-10 text-success">
                                                        <i className="bi bi-check-circle me-1"></i> Open
                                                    </span>
                                            ) : (
                                                <span className="badge bg-danger bg-opacity-10 text-danger">
                                                        <i className="bi bi-x-circle me-1"></i> Closed
                                                    </span>
                                            )}
                                        </td>
                                        <td className="pe-4">
                                            {hour.note ? (
                                                <small className="text-muted">{hour.note}</small>
                                            ) : (
                                                <span className="text-muted fst-italic">No notes</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {!loading && !isEditing && hours.length === 0 && (
                    <div className="text-center py-5">
                        <i className="bi bi-inbox display-4 text-muted"></i>
                        <p className="text-muted mt-3">No hours of operation configured</p>
                        <button
                            className="btn btn-primary btn-sm mt-2"
                            onClick={() => setIsEditing(true)}
                        >
                            <i className="bi bi-plus-circle me-1"></i> Add Hours
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HoursOfOperation;